<ul>
    <li>
       <ng-container *ngIf="viewMode == 'user'">
            <ng-container *ngIf="noshow.charge == null || noshow.charge_type == 0">
                •  {{ 'CANCELLATION_POLICIES.USER_WONT_BE_CHARGED' | translate }}
            </ng-container>
            <ng-container *ngIf="noshow.charge && noshow.charge_type == 3">
                •  {{ 'CANCELLATION_POLICIES.USER_CHARGED_NIGHT' | translate : { chargeValue: noshow.charge, s: noshow.charge > 1 ? 's' : '' } }}
            </ng-container>
            <ng-container *ngIf="noshow.charge && noshow.charge_type == 2">
                •  {{ 'CANCELLATION_POLICIES.USER_CHARGED_PERCENT' | translate : { chargeValue: noshow.charge } }}
            </ng-container>
            <ng-container *ngIf="noshow.charge && noshow.charge_type == 1">
                •  {{ 'CANCELLATION_POLICIES.USER_CHARGED_AMOUT_S' | translate }}
                <ng-container *ngIf="exchangeRate; else userCurrency">
                    {{ formatCurrency(noshow.charge, currency) }}
                </ng-container>
                <ng-template #userCurrency>
                    {{ noshow.charge | currencyConversion }}
                </ng-template>
                {{ 'CANCELLATION_POLICIES.USER_CHARGED_AMOUT_E' | translate }}
            </ng-container>
       </ng-container>

       <ng-container *ngIf="viewMode == 'admin' || viewMode == 'ota'">
            •  {{ 'CANCELLATION_POLICIES.VIEW_OTA' | translate }}
            <!-- Suffix -->
            <ng-container *ngIf="noshow.charge == null || noshow.charge_type == 0">
                {{ 'CANCELLATION_POLICIES.WONT_BE_CHARGED' | translate }}
            </ng-container>
            <ng-container *ngIf="noshow.charge && noshow.charge_type == 3">
                {{ 'CANCELLATION_POLICIES.CHARGED_NIGHT' | translate : { chargeValue: noshow.charge, s: noshow.charge > 1 ? 's' : '' } }}
            </ng-container>
            <ng-container *ngIf="noshow.charge && noshow.charge_type == 2">
                {{ 'CANCELLATION_POLICIES.CHARGED_PERCENT' | translate : { chargeValue: noshow.charge } }}
            </ng-container>
            <ng-container *ngIf="noshow.charge && noshow.charge_type == 1">
                {{ 'CANCELLATION_POLICIES.CHARGED_AMOUT' | translate }}
                <ng-container *ngIf="exchangeRate; else userCurrency">
                    {{ formatCurrency(noshow.charge, currency) }}
                </ng-container>
                <ng-template #userCurrency>
                    {{ noshow.charge | currencyConversion }}
                </ng-template>
            </ng-container>
       </ng-container>

       
   </li>
</ul>
